import script from "./CardWithCTABlock.vue?vue&type=script&lang=js"
export * from "./CardWithCTABlock.vue?vue&type=script&lang=js"

const __exports__ = script;

export default __exports__